import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

export default createTheme({
  palette: {
    primary: { main: '#3e4f7e' },
    secondary: { main: '#98272b' },
    default: { main: '#3e4f7e' },
    error: red
  },
  typography: {
    fontSize: 16
  }
});
